import { useCallback, useEffect, useState } from "react";

export const useHighlightFields = () => {
  const [highlightedFields, setHighlightedFields] = useState({
    input: [] as string[],
    output: [] as string[],
  });

  // resets highlighted fields after 10 seconds
  useEffect(() => {
    const timeout = setTimeout(() => {
      setHighlightedFields({
        input: [],
        output: [],
      });
    }, 10 * 1000);
    return () => clearTimeout(timeout);
  }, [highlightedFields]);

  const highlightInputFields = useCallback((fields: string[]) => {
    setHighlightedFields((prev) => ({
      ...prev,
      input: fields,
    }));
  }, []);

  const highlightOutputFields = useCallback((fields: string[]) => {
    setHighlightedFields((prev) => ({
      ...prev,
      output: fields,
    }));
  }, []);

  return {
    highlightedFields,
    highlightInputFields,
    highlightOutputFields,
  } as const;
};
